<template>
  <generic-list :apiUrls="apiUrls" :formCols="formCols" :updateCols="updateCols" :tableCols="tableCols"
    ref="genericList" @changePlatform="getAppVersion"></generic-list>
</template>

<script>
import genericList from '@/views/commonPage/genericList.vue'
import URL from '@/views/business/util/url'
import Qs from 'qs'
let isDelete = { "1": "启用", "2": "禁用" };
let forces = { "1": "是", "2": "否" };
let systemUpdate = { "1": "是", "2": "否" };
let platform = { "Android": "Android", "IOS": "IOS" };
let levelCard = {};
export default {
  name: "appUpdate",
  components: {
    genericList
  },
  created() {
    this.initLevel()
  },
  methods: {
    initLevel() {
      this.$axios.post(URL.common.configKey, Qs.stringify({
        // 如果需要传递参数，可以在这里传递
        paramKey: "miLevelDict"
      })).then(res => {
        if (res.code === 0) {
          if (res.result && res.result.paramValue) {
            //  console.log(res.result.paramValue);
            // 请求成功，将响应数据赋值给 levelCard
            this.levelCard = JSON.parse(res.result.paramValue);
          } else {
            console.error('请求失败');
          }
        } else {
          console.error('请求失败');
        }
      })
    },
    getAppVersion(updateModel, isOpenFunction, type) {
      if (!updateModel) {
        return;
      }
      this.$axios.post(URL.appVersion.query, Qs.stringify({
        platform: updateModel.platform,
        version: updateModel.version
      })).then(res => {
        if (res.code === 0) {
          const { versions, sources } = res.result.list.filter(item => item.isDelete === 1).reduce(
            (acc, item) => ({
              versions: { ...acc.versions, [item.version]: item.version },
              sources: { ...acc.sources, [item.utmSource]: item.utmSource },
            }),
            { versions: {}, sources: {} }
          );        
          if (updateModel.version){
            sources.all = "ALL";
            this.$set(this.updateCols.find(c => c.field === 'utmSource'), "optionList", sources);
            this.$refs.genericList.$refs.childUpdate.updateFormData("optionList", ['utmSource']);
          } else {
            this.$set(this.updateCols.find(c => c.field === 'version'), "optionList", versions);
            this.$refs.genericList.$refs.childUpdate.updateFormData("optionList", ['version']);
          }
          if (!isOpenFunction) {
            if (type === 'platform') {
              this.$refs.genericList.$refs.childUpdate.updateFormData("data", ['version', 'utmSource']);
            } else {
              this.$refs.genericList.$refs.childUpdate.updateFormData("data", ['utmSource']);
            }
          }
        }
      }).catch(res => {
        console.log("error")
      });
    }
  },
  watch: {
    levelCard: {
      deep: true,
      handler(newVal) {
        this.$set(this.formCols.find(c => c.field === 'grade'), "optionList", newVal);
        this.$set(this.updateCols.find(c => c.field === 'grade'), "optionList", newVal);
      }
    }
  },
  data() {
    return {
      levelCard: {},
      apiUrls: {
        query: URL.appUpdate.query,
        addOrUpdate: URL.appUpdate.addOrUpdate,
        deleteBatchIds: URL.appUpdate.deleteBatchIds,
        status: URL.appUpdate.status,
        platformList: URL.appUpdate.platformList
      },
      formCols: [
        { title: '渠道编号', field: 'utmSource' },
        { title: '版本号', field: 'version' },
        { title: '系统类型', field: 'platform', type: 2, optionList: platform },
        { title: '更新对象', field: 'grade', type: 2, multiple: true, optionList: levelCard, data: [] },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete },
        {
          title: '创建时间',
          field: 'time1',
          type: 6,
          format: 'yyyy-MM-dd HH:mm:ss',
          startEndParam: ['createDateBegin', 'createDateEnd']
        },
        { click: window.$t('business.bt.search') },
        { click: window.$t('business.bt.add') }
      ],
      updateCols: [
        { title: 'ID', field: 'id', hidden: true },
        {
          title: '系统类型', field: 'platform', type: 2, optionList: platform, required: true,
          change: (updateModel, cols, col) => {
            if (col.data) {
              this.getAppVersion(updateModel, false, "platform");
            }
          },
          readonly: (updateModel, col) => {
            return !!updateModel.id;
          }
        },
        {
          title: '版本号', field: 'version', type: 2, required: true, isNumber: true,
          readonly: (updateModel, col) => {
            return !!updateModel.id;
          },
          change: (updateModel, cols, col) => {
            if (col.data) {
              this.getAppVersion(updateModel, false, "version");
            }
          }
        },
        { title: '渠道编号', field: 'utmSource', type: 2, multiple: true, required: true },
        { title: '强制升级', field: 'forces', type: 2, optionList: forces, isNumber: true, required: true },
        { title: '系统内升级', field: 'systemUpdate', type: 2, optionList: systemUpdate, isNumber: true, required: true },
        { title: '升级对象', field: 'grade', type: 2, multiple: true, optionList: levelCard, data: [] },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete, isNumber: true, required: true },
        { title: '升级内容', field: 'content', type: 6, uploadUrl: URL.detailTask.uploadUrl, required: true },
      ],
      tableCols: [
        {
          title: '系统类型', field: 'platform', render: (data, full) => {
            return platform[data];
          }
        },
        { title: '版本号', field: 'version', h5Click: 'detail' },
        {
          title: '渠道编号', field: 'utmSource', minWidth: "180", render: (data, full) => {
            return Array.isArray(data) ? data.join(",") : data;
          }
        },
        {
          title: '升级对象', field: 'grade', type: 2, render: (data, full) => {
            if (data) {
              const grade = Array.isArray(data) ? data : (data || '').split(',');
              return grade.join(',');
            } else {
              return "all";
            }
          }
        },
        {
          title: '系统内升级', field: 'systemUpdate', render: (data, full) => {
            return systemUpdate[data];
          }
        },
        {
          title: '强制升级', field: 'forces', render: (data, full) => {
            return forces[data];
          }
        },
        { title: '创建人', field: 'createUser' },
        { title: '更改人', field: 'updateUser' },
        { title: '创建时间', field: 'createDate' },
        { title: '修改时间', field: 'updateDate' },
        {
          field: "isDelete", notice: function (value, row) {
            return (value === '1' || value === 1) ? '启用' : '禁用';
          },
          title: "启用/禁用开关",
          size: "mini", click: "status", stype: '100', activeText: "启用", inactiveText: "禁用", hidden: "true"
        },
        {
          title: "操作", minWidth: "180", btnClick: [
            { name: window.$t("business.bt.edit"), click: "update", type: "primary", size: "mini", icon: "el-icon-edit" },
            { name: window.$t("business.bt.delete"), click: "delete", type: "primary", size: "mini", icon: "el-icon-delete" }
          ]
        },
      ]
    };
  }
}
</script>